import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { Suspense } from "solid-js";
import "./app.css";
import { init as initClient } from "@repo/client";
import { MinimalLayoutProvider } from "~/components/layouts/minimal";
import { I18nProvider } from "~/i18n/context";
import { ArtifactStoreProvider } from "~/stores/ArtifactStore";
import { WireProvider } from "~/wire";

// App constructs the application and provides the main entry point for the
// application. It is responsible for initializing and rendering
// the application.
export default function App() {
  initClient(RUNNING_ENV, PULL_REQUEST_ID);
  return (
    <Suspense>
      <Router
        root={(props) => {
          return (
            <>
              <I18nProvider>
                <WireProvider>
                  <ArtifactStoreProvider>
                    <MinimalLayoutProvider>{props.children}</MinimalLayoutProvider>
                  </ArtifactStoreProvider>
                </WireProvider>
              </I18nProvider>
            </>
          );
        }}
      >
        <FileRoutes />
      </Router>
    </Suspense>
  );
}
